import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Ticketing from "../../../../mobileapp/Ticketing";

const MobileRoutes = () => {
  return (
    <div className="h100">
      <Router>
        <Routes>
          <Route path="/astram/ticketing" element={<Ticketing />} />
        </Routes>
      </Router>
    </div>
  );
};

export default MobileRoutes;
